import React from 'react'
import PropTypes from 'prop-types'

const ReaderNavigationOverview = props => {
  return (
    <li className="toolbar_item_section_title_container">
      <div className="section_title">{props.sectionTitle}</div>
    </li>
  )
}

ReaderNavigationOverview.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
}

export default ReaderNavigationOverview
